import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmationDialogComponent } from '@fuse/services/confirmation/dialog/dialog.component';
import { merge } from 'lodash-es';
import { GenericInfoDialogConfig } from './infoDialogConfig';

@Injectable({providedIn: 'root'})
export class GenericInfoDialogService
{
    private _matDialog: MatDialog = inject(MatDialog);
    private _defaultConfig: GenericInfoDialogConfig = {
        title      : 'Confirm action',
        message    : 'Are you sure you want to confirm this action?',
        icon       : {
            show : true,
            name : 'heroicons_outline:exclamation-triangle',
            color: 'info',
        },
        actions    : {
            confirm: {
                show : true,
                label: 'Confirm',
                color: 'primary',
            },
            cancel : {
                show : true,
                label: 'Cancel',
            },
        },
        dismissible: false,
        justifyButtonsBetween: false,
        panelClass: 'fuse-confirmation-dialog-panel',
    };

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    open(config: GenericInfoDialogConfig = {}): MatDialogRef<FuseConfirmationDialogComponent>
    {
        // Merge the user config with the default config
        const userConfig = merge({}, this._defaultConfig, config);

        // Open the dialog
        return this._matDialog.open(FuseConfirmationDialogComponent, {
            autoFocus   : false,
            disableClose: !userConfig.dismissible,
            data        : userConfig,
            panelClass  : userConfig.panelClass,
        });
    }
}
